var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.36 13.9642C12.9401 12.655 12.1154 11.513 11.0048 10.7028C9.89409 9.89263 8.5548 9.45605 7.18 9.45605C5.80519 9.45605 4.4659 9.89263 3.35521 10.7028C2.24453 11.513 1.41982 12.655 1 13.9642H13.36Z",
    stroke: "#009379",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17933 9.46411C9.51663 9.46411 11.4114 7.56935 11.4114 5.23205C11.4114 2.89475 9.51663 1 7.17933 1C4.84203 1 2.94727 2.89475 2.94727 5.23205C2.94727 7.56935 4.84203 9.46411 7.17933 9.46411Z",
    stroke: "#009379",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56263 6.86914C8.56263 6.86914 8.21148 7.56008 7.18073 7.56008C6.14998 7.56008 5.79883 6.86914 5.79883 6.86914",
    stroke: "#009379",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3363 4.4263C11.3268 4.42636 11.3174 4.42639 11.308 4.42639C10.0778 4.42639 8.97341 3.8882 8.21728 3.03444C7.46116 3.88822 6.35672 4.42642 5.12657 4.42642C4.41223 4.42642 3.74027 4.24493 3.1543 3.92555C3.70484 2.22764 5.29947 1 7.18084 1C9.24261 1 10.96 2.47437 11.3363 4.4263Z",
    stroke: "#009379",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.f1fef7358935a98cd78906d89a4d91cf.svg";
export { ForwardRef as ReactComponent };